import React from "react";
import PropTypes from "prop-types";
import Modal from "../../shared/modal";
import styles from "./styles.css";
import ThankyouImage from "./images/thank-you.svg";
import CloseButton from "../../shared/icon-cross";

const ContactUsThankyouModal = ({
    onClose
}) => {
    return (
        <React.Fragment>

            <Modal isOpen={true}>
                <div styleName={"styles.wrapper"}>
                    <span styleName={"styles.close"}><CloseButton onClickHandler={onClose} type={"grey"} /></span>
                    <h3 styleName={"styles.modalTitle"}>We’ve got your message!</h3>
                    <img src={ThankyouImage} styleName={"styles.modalImage"} alt="Thank You" />
                    <p styleName={"styles.modalContentText"}>Thanks for getting in touch with the Cars24 team. We will respond to you shortly.</p>
                </div>

            </Modal>

        </React.Fragment>
    );
};

ContactUsThankyouModal.propTypes = {
    onClose: PropTypes.func
};

export default ContactUsThankyouModal;
